'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import PortalIdParser from 'PortalIdParser';
const CURRENCY_SETTINGS = `/settings/${PortalIdParser.get()}/account-defaults/multicurrency`;

const GoToCurrencySettings = ({
  textKey = 'goToCurrencySettings'
}) => /*#__PURE__*/_jsx(UILink, {
  href: CURRENCY_SETTINGS,
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: `campaigns.multiCurrencyTooltip.${textKey}`
  })
});

export default GoToCurrencySettings;